import React from 'react'
import {MdOutlineEmail} from 'react-icons/md'
import {RiMessengerLine} from 'react-icons/ri'
import {BsWhatsapp} from 'react-icons/bs'
import {MdAttachFile}  from 'react-icons/md'
import { useRef } from 'react';
import emailjs from 'emailjs-com'
import { contactusdata } from '../data';

const ContactUs = () => {
    const form = useRef();

    const sendEmail = (e) => {
      e.preventDefault();
  
      emailjs.sendForm('service_3fjfb17', 'template_ky1ucaz', form.current, 'user_641J0AWGxx4qcKi835yDq')
  
      e.target.reset()
    };

  return (
    <section className="contactus">
        <div className="container contactus-title-container">
            <h1>Let's Talk</h1>
            <p>SEND THE EMAIL</p>
        </div>
        <div className="container contactus-container">
            <div className="contactus__options">
                <article className="contactus__option">
                    <div className='contactus__option-top'>
                        <p>Email</p>
                        <MdOutlineEmail className='contactus__option-icon'/>
                    </div>
                    <a href={`'mailto:' + ${contactusdata[0].email}`} target="_blank">{contactusdata[0].email}</a>
                    {/* <a href={`'mailto:' + ${contactusdata.email}`} target="_blank">Send a message</a> */}
                </article>
                <article className="contactus__option">
                    <div className='contactus__option-top'>
                    <p>Messager</p> 
                        <RiMessengerLine className='contactus__option-icon2'/>
                        
                    </div>
                    <a href="https://m.me/ernest.achiever" target="_blank">{contactusdata[0].messenger}</a>
                    {/* <a href="https://m.me/madmonk.achiever" target="_blank">Send a message</a> */}
                </article>
                <article className="contactus__option">
                    <div className='contactus__option-top'>
                    <p>WhatsApp</p>
                        <BsWhatsapp className='contactus__option-icon3'/>
                        
                    </div>
                    <a href={`"https://api.whatsapp.com/send?phone=" + ${contactusdata[0].whatsapp}`} target="_blank">{contactusdata[0].whatsapp}</a>
                    {/* <a href={`"https://api.whatsapp.com/send?phone=" + ${contactusdata.whatsapp}`} target="_blank">Send a message</a> */}
                </article>
            </div>
            {/* END OF CONTACT OPTIONS */}
            <form ref={form} onSubmit={sendEmail}>
                <input type="text" name='name' placeholder='NAME' required />
                <input type="email" name='email' placeholder='YOUR EMAIL' required />
                <textarea name="message" rows={7} placeholder='TELL US ABOUT YOUR PROJECT' required ></textarea>
                <div className='contactus_btn_container'>
                <button type='file' name='file' className='attachment_btn'><MdAttachFile className='attachment_icon'/> Add Attachment</button>
                <button type='submit' className='trans_onwhite_btn'>Send Message</button>
                </div>
            </form>
            <div></div>
            <p className='agreement'>
            I agree that my data in this form will be sent to contact@mm-space.com and will be read by human beings. We will answer you as soon as possible. If you sent this form by mistake or want to remove your data, you can let us know by sending an email to contact@prographers.com. We will never send you any spam or share your data with third parties
            </p>
        </div>
    </section>
  )
}

export default ContactUs